import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const ExportFormatSelector = ({ selectedFormat, onFormatChange }) => {
  const formats = [
    {
      value: 'csv',
      label: 'CSV',
      icon: 'FileSpreadsheet',
      description: 'Data analysis ready',
      biReady: true,
      color: 'text-green-600'
    },
    {
      value: 'excel',
      label: 'Excel',
      icon: 'FileSpreadsheet',
      description: 'Formatted with charts',
      biReady: true,
      color: 'text-blue-600'
    },
    {
      value: 'json',
      label: 'JSON',
      icon: 'Code',
      description: 'API integration',
      biReady: true,
      color: 'text-purple-600'
    },
    {
      value: 'pdf',
      label: 'PDF',
      icon: 'FileText',
      description: 'Executive summary',
      biReady: false,
      color: 'text-red-600'
    }
  ];

  return (
    <div className="card">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Download" size={20} className="text-primary" />
        <h3 className="text-lg font-semibold text-foreground">
          Export Format
        </h3>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {formats?.map((format) => (
          <button
            key={format?.value}
            onClick={() => onFormatChange(format?.value)}
            className={cn(
              'flex flex-col items-center gap-2 p-4 rounded-lg border-2 transition-all duration-200',
              selectedFormat === format?.value
                ? 'border-primary bg-primary/10' :'border-border hover:border-primary/50'
            )}
          >
            <Icon
              name={format?.icon}
              size={24}
              className={cn(
                selectedFormat === format?.value
                  ? 'text-primary'
                  : format?.color
              )}
            />
            <div className="text-center">
              <span
                className={cn(
                  'text-sm font-semibold block',
                  selectedFormat === format?.value
                    ? 'text-primary' :'text-foreground'
                )}
              >
                {format?.label}
              </span>
              <span className="text-xs text-muted-foreground block mt-1">
                {format?.description}
              </span>
              {format?.biReady && (
                <span className="inline-flex items-center gap-1 mt-2 px-2 py-0.5 bg-green-100 text-green-700 text-xs rounded-full">
                  <Icon name="Database" size={10} />
                  BI-Ready
                </span>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExportFormatSelector;